export const MODULES = {
  POLICY_ADMIN:      'policy_management',
  CLAIMS:            'claims_management',
  CLIENT_AGENT:      'client_agent_management',
  BILLING_FINANCE:   'billing_finance',
  ANALYTICS:         'analytics',
  AI_COPILOT:        'ai_copilot',
  STP:               'stp',
  HR:                'hr_management',
  INTEGRATION:       'integration',
  FAST_INSPECTIONS:  'fast_inspections',
} as const;

export type ModuleId = typeof MODULES[keyof typeof MODULES];
